import { Component, Inject, Injector, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormComponent, IFormDialogData } from 'src/app/shared/form/form.component';
import { AnalyticalMethod } from 'src/app/models/analyticalMethod.model';
import { TextFormField } from 'src/app/shared/form/formField.model';
import nameOf from 'src/app/shared/form/nameOf.helper';
import { AnalyticalMethodService } from 'src/app/services/analytical-method.service';

@Component({
  standalone: false,
  selector: 'app-analytical-method-dialog',
  templateUrl: './../../shared/form/form.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./../../shared/form/form.component.scss']
})
export class AnalyticalMethodDialogComponent extends FormComponent<AnalyticalMethod> implements OnInit {

  constructor(
    dialogRef: MatDialogRef<AnalyticalMethodDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: IFormDialogData,
    analyticalMethodService: AnalyticalMethodService,
    protected injector: Injector
  ) {
    super(dialogRef, analyticalMethodService, data, 'Analytical Method', injector);
  }

  ngOnInit(): void {
    this.isFormLoading = true;
    this.getEntity().subscribe({
      next: (entity) => {
        this.entity = entity;
        this.initFields();
        this.isFormLoading = false;
      },
      error: (error) => {
        this.toastService.showError(error);
        this.isFormLoading = false;
      }
    });
  }

  getNewObject(): AnalyticalMethod {
    return new AnalyticalMethod();
  }

  validate(): boolean {
    return true;
  }

  initFields(): void {
    this.fields = [
      new TextFormField({
        property: nameOf<AnalyticalMethod>(x => x.methodName),
        name: 'Method Name'
      }),
      new TextFormField({
        property: nameOf<AnalyticalMethod>(x => x.agency),
        name: 'Agency', required: false
      }),
      new TextFormField({
        property: nameOf<AnalyticalMethod>(x => x.instrumentation),
        name: 'Instrumentation', required: false
      }),
      new TextFormField({
        property: nameOf<AnalyticalMethod>(x => x.description),
        name: 'Description', required: false
      }),
      new TextFormField({
        property: nameOf<AnalyticalMethod>(x => x.url),
        name: 'URL', required: false
      })
    ];
  }
}
